var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("badge"),
      _vm._v(" "),
      _vm.hasProRight
        ? _c("span", [
            _vm.showBadge
              ? _c(
                  "span",
                  {
                    staticClass:
                      "tinyBadge tinyBadge--green float-right margin-top-5",
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.trans("SEARCH_PRO_BADGE_TEXT")) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm.showBadge
        ? _c(
            "span",
            [
              _vm.userFeature
                ? [
                    _vm.entityId === "gcs" && !_vm.hasCloudRight
                      ? _c(
                          "Tooltip",
                          {
                            attrs: {
                              settings: { target: ".badgeTooltipGcsUpgrade" },
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fa fa-times-circle text-color--red float-right",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _c(
                          "Tooltip",
                          {
                            attrs: {
                              content: _vm.trans(
                                "SEARCH_PREMIUM_CONTENT_ACCESS"
                              ),
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fa fa-check-circle text-color--green float-right",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                  ]
                : _c(
                    "Tooltip",
                    { attrs: { settings: { target: ".badgeTooltip" } } },
                    [
                      _c("i", {
                        staticClass:
                          "fa fa-times-circle text-color--red float-right",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.collapsible
        ? _c(
            "button",
            {
              staticClass: "entity__collapsible",
              attrs: { type: "button", "aria-label": _vm.trans("SHOW_MORE") },
              on: { click: _vm.toggleCollapse },
            },
            [
              _c("i", {
                staticClass: "fa",
                class: _vm.collapsed ? "fa-chevron-down" : "fa-chevron-up",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.isChecked,
            expression: "isChecked",
          },
        ],
        ref: "checkbox",
        staticClass: "entity__checkbox",
        attrs: {
          id: _vm.entityId,
          type: "checkbox",
          "aria-labelledby": `entity__checkboxLabel--${_vm.name}`,
          name: _vm.name,
          disabled: _vm.isDisabled,
        },
        domProps: {
          value: _vm.value,
          checked: Array.isArray(_vm.isChecked)
            ? _vm._i(_vm.isChecked, _vm.value) > -1
            : _vm.isChecked,
        },
        on: {
          change: [
            function ($event) {
              var $$a = _vm.isChecked,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = _vm.value,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.isChecked = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.isChecked = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.isChecked = $$c
              }
            },
            _vm.checkThis,
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "entity__label",
          attrs: {
            id: `entity__checkboxLabel--${_vm.name}`,
            "data-area": _vm.name,
          },
          on: { click: _vm.singleCheck },
        },
        [
          _vm._t("label"),
          _vm._v(" "),
          _vm.foundResults
            ? _c(
                "span",
                {
                  staticClass: "font-italic",
                  attrs: { id: `entity__spanValue--${_vm.name}` },
                },
                [
                  _vm._v("("),
                  _c("span", {
                    attrs: { "data-value": _vm.foundResultsOriginal },
                    domProps: { innerHTML: _vm._s(_vm.foundResults) },
                  }),
                  _vm._v(")\n        "),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.collapsed ? "hidden" : "padding-top-10 visible" },
        [_vm._t("target")],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }